"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nFlag = void 0;
var I18nFlag = '__i18n__';

/**
 * css module variables
 *
 * ! should not add new variables more, use Juno token please
 */
exports.I18nFlag = I18nFlag;
//# sourceMappingURL=BrandConfig.interface.js.map
